import {Component, OnInit} from '@angular/core';
import {TypeSignature} from '../../../global/util/TypeSignature';
import {Person} from '../../../user/model/Person';
import {Dialog} from '../../../global/util/Dialog';
import {InformType} from '../../../global/util/enum/InformType';
import {ActivatedRoute, Router} from '@angular/router';
import {Document} from '../../../user/model/Document';
import {Constant} from '../../../global/util/Constant';
import {StringUtil} from '../../../global/util/StringUtil';
import HttpStatusCode from '../../../global/util/HttpStatusCode';
import {ApplicationService} from '../../../user/service/application.service';
import {PublicService} from '../../../user/service/public.service';
import {FormBuilder, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {UanatacaService} from '../../../user/service/uanataca.service';
import {GeolocationIofesign} from '../../../user/model/GeolocationIofesign';
import {LocalStorage} from '../../../global/util/LocalStorage';
import {GeolocationService} from '../../../user/service/geolocation.service';

@Component({
  selector: 'app-request-onesign-otp-code',
  templateUrl: './request-onesign-otp-code.component.html',
  styleUrls: ['./request-onesign-otp-code.component.css']
})
export class RequestOnesignOtpCodeComponent implements OnInit {
  public signatureForm: any;
  public signCompleted: any;
  public completeData: boolean;
  public enableOTP = false;
  public document: any;
  public person: Person;
  public secondLeft = 0;
  private intervalCountDown: any;
  public codeSent = false;
  public cloudSignature = TypeSignature.CLOUD;
  public codeOTP: string;
  public hashIdentifier: any;
  public personId: number;
  public loading: boolean;
  public uanatacaRequestId: number;
  public messageErrorRequest = '';
  public isValidCode = false;
  private geolocation: GeolocationIofesign;
  private longitude = null;
  private latitude = null;
  private accuracy = null;
  public requestMessage = '';
  public showMessageInfo = false;
  public isInvalidControlOtp = true;

  constructor(private activatedRoute: ActivatedRoute,
              private applicationService: ApplicationService,
              private route: Router,
              private uanatacaService: UanatacaService,
              public translate: TranslateService,
              private geolocationService: GeolocationService,
              private formBuilder: FormBuilder,
              private publicService: PublicService) {
    this.receiveParams();
    this.createForm();
  }

  ngOnInit(): void {
    if (!this.document) {
      this.navigatePrincipalUrl();
    }
    this.enableOTP = false;
    this.loadInitialData();
    // const backOtpScreen = LocalStorage.getItem('backOtpCode');
    if (!LocalStorage.getItem('backOtpCode')) {
      this.generateOTP(true);
    }
  }


  public receiveParams() {
    this.activatedRoute.params.subscribe(params => {
      this.hashIdentifier = params.hashIdentifier;
      this.personId = +params.personId;
    });
    this.document = history.state.document;
    this.person = history.state.person;
  }


  private countDown() {
    this.secondLeft = 60;
    this.enableOTP = true;
    this.intervalCountDown = setInterval(() => {
      this.secondLeft = Math.floor(this.secondLeft - 1);
      // @ts-ignore
      if (this.secondLeft === 0) {
        this.enableOTP = false;
        clearInterval(this.intervalCountDown);
        const btnElement = document.getElementById('btnSendOTP');
        btnElement.removeAttribute('disabled');
      }
    }, 1000);
  }

  public createForm() {
    this.signatureForm = this.formBuilder.group(
      {
        codeOTP: [''],
      });
  }

  public generateOTP(initialLoad: boolean) {
    this.requestMessage = '';
    this.messageErrorRequest = '';
    const documents: Document[] = [];
    documents.push(this.document);
    this.loading = true;
    this.countDown();
    const url = Constant.ROOT_API_V1.concat('/public/uanataca/requests/', String(this.uanatacaRequestId), '/otp?uuid=', this.document._more.uuid);
    this.uanatacaService.post(url, null).subscribe(value => {
      const phoneNumber = this.document._more.phoneNumber;
      const splited = StringUtil.splitBy(phoneNumber, 3);
      this.loading = false;
      if (value) {
        this.codeSent = value;
        const btnElement = document.getElementById('btnSendOTP');
        btnElement.setAttribute('disabled', 'disabled');
        if (!initialLoad) {
          this.requestMessage = this.translate.instant('MESSAGE.CODE-SENT-TO-CELL-PHONE') + phoneNumber.charAt(0) + '*****' + splited[splited.length - 1];
        } else {
          this.requestMessage = '';
        }
      }
    }, error => {
      this.loading = false;
      this.signCompleted = false;
      this.messageErrorRequest = error.error.message;
      if (error.error.status === HttpStatusCode.CONFLICT) {
        this.navigatePrincipalUrl();
      } else if (error.error.status === HttpStatusCode.INTERNAL_SERVER_ERROR) {
        this.messageErrorRequest = error.error.message + ' ' + this.translate.instant('MESSAGE.MAKE-CODE-REQUEST');
      }
    });
  }

  private loadInitialData() {
    this.signatureForm.get('codeOTP').setValidators(
      Validators.compose(
        [
          Validators.required,
          Validators.pattern('^[0-9]{6}')])
    );
    this.signatureForm.get('codeOTP').updateValueAndValidity();
    this.uanatacaRequestId = this.document._more.uanatacaRequestId;
  }

  signCloud() {
    this.messageErrorRequest = '';
    this.requestMessage = '';
    this.loading = true;
    this.showMessageInfo = false;
    this.codeOTP = this.signatureForm.get('codeOTP').value;
    const url = Constant.ROOT_API_V1.concat('/public/uanataca/requests/', String(this.uanatacaRequestId), '/codeotp/', this.codeOTP, '/documents/sign?uuid=', this.document._more.uuid);
    this.uanatacaService.post(url, [this.document]).subscribe(value => {
      if (value) {
        this.signCompleted = true;
        this.saveGeolocation([this.document], this.personId, 'Firma OneSign');
        LocalStorage.removeItem('backOtpCode');
        this.navigateDocumentSigned();
        this.loading = false;
      }
    }, error => {
      this.loading = false;
      this.signCompleted = false;
      if (HttpStatusCode.FORBIDDEN === error.status) {
        this.messageErrorRequest = error.error.message;
        this.showMessageInfo = true;
      } else if (HttpStatusCode.INTERNAL_SERVER_ERROR === error.status) {
        this.messageErrorRequest = error.error.message;
      } else if (HttpStatusCode.UPGRADE_REQUIRED === error.status) {
        this.messageErrorRequest = error.error.message;
        return;
      } else if (HttpStatusCode.FOUND === error.status) {
        this.messageErrorRequest = error.error.message;
        return;
      } else {
        this.messageErrorRequest = error.error.message;
      }
    });
  }

  private saveGeolocation(documents: Document[], personId: number, signatureType: string) {
    // tslint:disable-next-line:prefer-for-of
    for (let index = 0; index < documents.length; index++) {
      const date = new Date(Date.now());
      const documentId = documents[index].id;
      this.geolocation = this.setValueGeolocation(documentId, personId);
      this.geolocation.signatureType = signatureType;
      this.geolocation.longTime = Date.now().toString();
      this.geolocation.timeStamp = date.toString();
      this.geolocation.timeZone = this.getGMT(date);
      this.geolocation.identification = null;
      this.geolocationService.save(this.geolocation).subscribe(resp => {

      }, error => {
        Dialog.show(InformType.Danger, 'Localización', 'No se pudo guardar su ubicación.');
      });
    }
  }

  private setValueGeolocation(documentId: number, personId: number) {
    this.geolocation = new GeolocationIofesign();
    this.geolocation.latitude = String(this.latitude);
    this.geolocation.longitude = String(this.longitude);
    this.geolocation.accuracy = String(this.accuracy);
    this.geolocation.documentId = documentId;
    this.geolocation.personId = personId;
    this.geolocation.ip = LocalStorage.getIpAddress();
    return this.geolocation;
  }

  navigatePrincipalUrl() {
    this.route.navigate(['document/' + this.hashIdentifier + '/people/' + this.personId + '/sign']).then();
  }

  goBack() {
    localStorage.setItem('backOtpCode', 'true');
    if (LocalStorage.getItem('termConditionAccepted') === 'true') {
      this.hasConfigRubric ? this.navigateNextScreen(this.hashIdentifier, this.personId, 'add-or-draw-rubric') : this.navigateNextScreen(this.hashIdentifier, this.personId, 'viewer');
    } else {
      this.navigateNextScreen(this.hashIdentifier, this.personId, 'terms-conditions');
    }
  }

  get hasConfigRubric(): boolean {
    if (this.document !== undefined) {
      return this.document._more.hasRubricSettings;
    }
  }

  private navigateDocumentSigned() {
    this.navigateNextScreen(this.hashIdentifier, this.personId, 'document-signed');
  }

  /**
   * Este método recibe paramatros para navegar entre pantallas.
   * @param hashIdentifier :
   */
  private navigateNextScreen(hashIdentifier: any, personId: any, nameUrl: any) {
    this.route.navigate(['document/' + hashIdentifier + '/people/' + personId + '/' + nameUrl + '/'], {
      state: {
        document: this.document,
        person: this.person
      }
    }).then();
  }

  private getGMT(date: Date) {
    return date.toTimeString().split(' ')[1];
  }

  public isInvalidControl(ctrlName: string) {
    return this.signatureForm.get(ctrlName).invalid && this.signatureForm.get(ctrlName).touched;
  }

  get messagePhoneNumber() {
    const phoneNumber = this.document._more.phoneNumber;
    const splited = StringUtil.splitBy(phoneNumber, 3);
    return phoneNumber.charAt(0) + '*****' + splited[splited.length - 1];
  }

  get isEnable4sendOTP(): boolean {
    return this.enableOTP;
  }

  get isCloudSignature(): boolean {
    return TypeSignature.CLOUD === this.document._more.typeSignature;
  }

  get messageInfo() {
    const message = this.translate.instant('MESSAGE.SEND-CODE-VERIFICATION-PHONE-NUMBER');
    return message.replaceAll('P_PARAM', this.messagePhoneNumber);
  }
}
